import React from 'react';
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useIceSurface } from '../../hooks/useIceSurface';

interface RemoveWizardModalProps {
  open: boolean;
  hasApprentice: boolean;
  busy: boolean;
  retainVaultItems: boolean;
  onRetainVaultItemsChange: (value: boolean) => void;
  onClose: () => void;
  onConfirmDelete: () => void;
  onConfirmDeleteAndPromote: () => void;
}

export const RemoveWizardModal: React.FC<RemoveWizardModalProps> = ({
  open,
  hasApprentice,
  busy,
  retainVaultItems,
  onRetainVaultItemsChange,
  onClose,
  onConfirmDelete,
  onConfirmDeleteAndPromote,
}) => {
  const paperSurface = useIceSurface({ icicles: true, card: true });

  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: {
          sx: {
            ...paperSurface,
          },
        },
      }}
    >
      <DialogTitle>Remove Wizard</DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>
          What would you like to do with this wizard?
        </Typography>
        {hasApprentice && (
          <Typography variant="body2" color="text.secondary">
            You can, optionally, promote your apprentice to take the wizard role. This applies a 6 level penalty and cannot be undone.
          </Typography>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={retainVaultItems}
              onChange={(e) => onRetainVaultItemsChange(e.target.checked)}
              size="small"
              disabled={busy}
            />
          }
          label={<Typography variant="body2">Keep equipment in vault</Typography>}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirmDelete}
          disabled={busy}
          startIcon={busy ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {busy ? 'Working...' : 'Delete'}
        </Button>
        {hasApprentice && (
          <Button
            variant="contained"
            color="error"
            onClick={onConfirmDeleteAndPromote}
            disabled={busy}
            startIcon={busy ? <CircularProgress size={18} color="inherit" /> : undefined}
          >
            {busy ? 'Working...' : 'Promote Apprentice'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
